module.exports = __webpack_public_path__ + "static/media/premium.698e1e1e.png";